import { render, staticRenderFns } from "./GenderPopup.vue?vue&type=template&id=34341f70&"
import script from "./GenderPopup.vue?vue&type=script&lang=js&"
export * from "./GenderPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports